export default class WsValidationMessagesController {
  static $inject = ['wsValidatorService'];

  constructor(wsValidatorService) {
    this.wsValidatorService = wsValidatorService;
  }
}



// WEBPACK FOOTER //
// ./src/form/validation/ws-validation-messages.controller.js